//@flow

export const EntityImportStateChart = {
    initial: 'registerWorker',
    states: {
        registerWorker: {
            on: {
                REGISTER_SUCCESS: 'fileUpload'
            },
            initial: 'loading',
            states: {
                loading: {}
            }
        },
        fileUpload: {
            on: {
                FILE_UPLOAD_SUCCESS: 'entityProcessing'
            },
            initial: 'idle',
            states: {
                idle: {
                    on: {
                        FILE_UPLOAD_START: {
                            uploading: {}
                        }
                    }
                },
                uploading: {
                    on: {
                        FILE_UPLOAD_ERROR: 'error'
                    }
                },
                error: {
                    on: {
                        TRY_AGAIN: 'idle'
                    }
                }
            }
        },
        entityProcessing: {
            initial: 'entityValidations',
            on: {
                RESET_ENTITY_IMPORT: 'fileUpload'
            },
            states: {
                entityValidations: {
                    on: {
                        NEXT: 'upload'
                    },
                    initial: 'existingIdsFetch',
                    states: {
                        existingIdsFetch: {
                            initial: 'validating',
                            on: {
                                NO_EXISTING_ENTITIES_FOUND: 'otherValidations',
                                EXISITING_ENTITIES_FOUND: 'idValidations',
                                RESERVED_ENTITIES_FOUND: 'removeIds',
                                NO_IDS_TO_UPLOAD: 'idValidations.noIdsToUpload'
                            },
                            states: {
                                validating: {
                                    onEntry: 'validateEntityIds'
                                }
                            }
                        },
                        idValidations: {
                            onEntry: 'getIdValidationTables',
                            initial: 'markIds',
                            on: {
                                NEXT: 'otherValidations',
                                UPDATE_IDS: '.markIds',
                                ALL_IDS_MARKED: '.allIdsMarked',
                                ALL_IDS_IGNORED: '.allIdsIgnored'
                            },
                            states: {
                                markIds: {},
                                allIdsMarked: {},
                                allIdsIgnored: {},
                                noIdsToMark: {},
                                noIdsToUpload: {}
                            }
                        },
                        removeIds: {
                            onEntry: 'getIdValidationTables',
                            initial: 'noIdsToMark',
                            on: {
                                NEXT: 'otherValidations'
                            },
                            states: {
                                markIds: {},
                                allIdsMarked: {},
                                allIdsIgnored: {},
                                noIdsToMark: {}
                            }
                        },
                        otherValidations: {
                            initial: 'fetchingOtherValidationTable',
                            states: {
                                fetchingOtherValidationTable: {
                                    onEntry: 'setOtherValidationsTable',
                                    on: {
                                        SHOW_VALIDATION_TABLE:
                                            'showValidationTable'
                                    }
                                },
                                showValidationTable: {}
                            },
                            on: {
                                BACK: 'idValidations.allIdsMarked'
                            }
                        }
                    }
                },
                upload: {
                    initial: 'fetchData',
                    on: {
                        BACK: 'entityValidations.otherValidations'
                    },
                    states: {
                        fetchData: {
                            onEntry: 'getUploadSummaryData',
                            on: {
                                NO_UPLOAD: 'noUpload',
                                SUMMARY: 'summary'
                            }
                        },
                        summary: {
                            on: {
                                NEXT: {
                                    uploading: { actions: ['uploadEntities'] }
                                }
                            }
                        },
                        noUpload: {},
                        uploading: {
                            on: {
                                ENTITY_UPLOAD_SUCCESS: 'success',
                                ENTITY_UPLOAD_ERROR: 'summary'
                            }
                        },
                        success: {}
                    }
                }
            }
        }
    }
};

export default EntityImportStateChart;
